import gql from 'graphql-tag';
import { RoomCollaboratorSchema } from '../../definitions/schemas';
import Interface from '../Interface';
import { CollaboratorType } from '../../enums/CollaboratorType';

interface CreateRoomCollaboratorInput {
  collaboratorId: string;
  collaboratorType: CollaboratorType;
  emailNotification: boolean;
  roleDescription?: string;
  roomId: string;
  sellingTeam: boolean;
}

interface UpdateRoomCollaboratorInput {
  id: string;
  emailNotification?: boolean;
  roleDescription?: string;
  sellingTeam?: boolean;
}

interface DeleteRoomCollaboratorInput {
  id: string;
}

export default class RoomCollaboratorsInterface extends Interface {
  public async create(input: CreateRoomCollaboratorInput) {
    return this.mutate<RoomCollaboratorSchema>(
      async () => {
        const response = await this.apolloService.executeMutation({
          mutation: gql`
            mutation createRoomCollaborator(
              $input: CreateRoomCollaboratorInput!
            ) {
              createRoomCollaborator(input: $input) {
                errors
              }
            }
          `,
          variables: {
            input,
          },
        });

        const { errors, message, roomCollaborator } =
          response.data.createRoomCollaborator;

        return {
          data: roomCollaborator,
          serverErrors: errors || response.errors,
          serverMessage: message || response.errors?.join(','),
        };
      },
      'Error creating room collaborator',
      true
    );
  }

  public async update(input: UpdateRoomCollaboratorInput) {
    return this.mutate<RoomCollaboratorSchema>(async () => {
      const response = await this.apolloService.executeMutation({
        mutation: gql`
          mutation updateRoomCollaborator(
            $input: UpdateRoomCollaboratorInput!
          ) {
            updateRoomCollaborator(input: $input) {
              errors
              message
              roomCollaborator {
                id
              }
            }
          }
        `,
        variables: {
          input,
        },
      });

      const { errors, message, roomCollaborator } =
        response.data.updateRoomCollaborator;

      return {
        data: roomCollaborator,
        serverErrors: errors,
        serverMessage: message,
      };
    }, 'Error updating room collaborator');
  }

  public async delete(input: DeleteRoomCollaboratorInput) {
    return this.mutate<null>(
      async () => {
        const response = await this.apolloService.executeMutation({
          mutation: gql`
            mutation deleteRoomCollaborator(
              $input: DeleteRoomCollaboratorInput!
            ) {
              deleteRoomCollaborator(input: $input) {
                errors
                message
              }
            }
          `,
          variables: {
            input,
          },
        });

        const { errors, message } = response.data.deleteRoomCollaborator;

        return {
          data: null,
          serverErrors: errors?.join(','),
          serverMessage: message,
        };
      },
      'Error deleting room collaborator',
      true
    );
  }
}
